import '@/user/common';
import 'slick-carousel';
import $ from 'jquery';

// 画像のカルーセルスライダー
const imageSlider = () => {
    $('.slick_slider').slick({
        dots: true,
        prevArrow: '<div class="slick-prev border-color--accent-after"></div>',
        nextArrow: '<div class="slick-next border-color--accent-after"></div>',
    });
};

$(() => {
    // 初期表示
    imageSlider();
});
